



















import { computed, defineComponent, ref, useContext, useFetch, useRoute } from '@nuxtjs/composition-api';
import AppLoader from '~/components/partials/App/AppLoader.vue';
import CollegeHeader from '~/components/partials/College/CollegeHeader.vue';
import QuestionCard from '~/components/partials/College/QuestionCard.vue';
import LayoutDefault from '~/components/partials/Layout/LayoutDefault.vue';
import { useCollege } from '~/composables/college/useCollege';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { useLayoutProps } from '~/composables/useLayoutProps';
import { useStore } from '~/composables/useStore';
import { PageError } from '~/utils/error';
import { CollegeLessonQuiz } from '~/types/common';
import { ArticleType, CollegeLessonType } from '~/enums';

export default defineComponent({
  components: {
    AppLoader,
    LayoutDefault,
    QuestionCard,
    CollegeHeader,
  },
  setup() {
    const { i18n } = useContext();
    const { isEnotecaAppWebView } = useEnotecaApp();
    const { getLessonDetail } = useCollege();
    const store = useStore();
    const route = useRoute();
    const routeParams = route.value.params;
    const quiz = ref<CollegeLessonQuiz>();
    const isLoading = ref(true);
    const lessonTitle = computed(() =>
      i18n.t('College-02.quiz.list.title.basic', { title: store.state.college.detail.lessonInfo.title }).toString()
    );

    const { fetchState } = useFetch(async () => {
      try {
        // URL直打ちなどで講座情報をストアに格納できていない場合は、講座詳細を取得する
        if (!store.state.college.detail.lessonInfo.title || !store.state.college.detail.lessonInfo.quizIds.length) {
          await getLessonDetail(Number(routeParams.id), ArticleType.BasicLesson);
        }

        const quizId = store.state.college.detail.lessonInfo.quizIds[Number(routeParams.page) - 1];
        // 存在しないページ番号の場合は404エラーを返す
        if (!quizId) {
          throw new PageError(404, {});
        }
        quiz.value = await store.dispatch('college/quiz/fetchLessonQuiz', {
          quizId: Number(quizId),
        });
      } catch {
        throw new PageError(404, {});
      } finally {
        isLoading.value = false;
      }
    });

    useLayoutProps(() => ({
      layout: {
        header: isEnotecaAppWebView.value ? 'never' : 'always',
        headerMenu: 'never',
        helloBar: isEnotecaAppWebView.value ? 'never' : 'needed',
        footer: isEnotecaAppWebView.value ? 'never' : 'always',
        footerMenu: isEnotecaAppWebView.value ? 'never' : 'always',
      },
      head: {
        title: i18n.t('College-03.quiz.title').toString(),
      },
      fetchState,
    }));
    return {
      CollegeLessonType,
      lessonTitle,
      quiz,
      isEnotecaAppWebView,
      isLoading,
    };
  },
});
